/**
 * Passed to Zod validators to return a nicer "required" error message
 * instead of whatever default message a ZodType would give.
 *
 * This is used to make front end validation errors more user-friendly.
 */
export const RequiredMessage = { message: 'Required' };
